import * as actions from './userGroup/actions'
import * as mutations from './userGroup/mutations'
import * as getters from './userGroup/getters'

import { dataProps } from './userGroup/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/userGroup.js